import React, { FC, useEffect, useState } from 'react';
import Section from '@widgets/components/section';
import { IHosting } from '@entities/hosting/IHosting';
import SectionHeader from '@widgets/components/section-header';
import TagInput from '@widgets/tag-input';
import InputFiles from '@shared/uikit/input-files';
import {
  Table,
  TableActionTd,
  TableActionTh,
  TableBody,
  TableTd,
  TableTh,
  TableThead,
  TableTr,
} from '@widgets/table';
import { Link } from 'react-router-dom';
import ValueWithSign from '@widgets/table/components/value-with-sign';
import Paginator, { DEFAULT_PER_PAGE } from '@widgets/paginator';
import EmptyList from '@widgets/empty-list';
import { ListLoader } from '@shared/uikit/loader';
import { ISelectOption } from '@widgets/multi-select';
import { toast } from 'react-toastify';
import {
  ICustomerMiningAccountList,
  useCustomerMiningAccountList,
} from '@app/queries/customer/useCustomerMiningAccountList';
import usePage from '@app/hooks/usePage';
import useSort from '@app/hooks/useSort';
import {
  IHostingClientsList,
  useHostingClientList,
} from '@app/queries/hosting/useHostingClientList';
import DropdownButton from '@widgets/dropdown-button';
import IconArrowUp from '@shared/icons/IconArrowUp';

interface IManagerInfoProps {
  hosting?: IHosting | null;
}
const HostingClientsTab: FC<IManagerInfoProps> = ({ hosting }) => {
  const hostingClientListFetcher = useHostingClientList();

  const [clientList, setClientList] = useState<IHostingClientsList | null>(null);
  const [page, setPage] = usePage();
  const [sort, setSort] = useSort();
  const [bulkItems, setBulkItems] = useState<number[]>([]);

  useEffect(() => {
    (async () => {
      const data = await hostingClientListFetcher.fetch({
        clientId: `${hosting?.id}`,
        page: page + 1,
        sort: sort,
      });
      setClientList(data);
    })();
  }, [hosting, sort?.type, sort?.column]);

  const actions: ISelectOption[] = [
    { value: 'attach', label: 'Привязать' },
    { value: 'unload', label: 'Редактировать' },
    { value: 'remove', label: 'Удалить' },
  ];

  const tempLeftActions: ISelectOption[] = [
    { value: '1', label: 'Все' },
    { value: '2', label: '1' },
    { value: '3', label: '2' },
  ];

  const handleAction = (value: string) => {
    switch (value) {
      case 'attach':
        if (!bulkItems.length) {
          toast.error('Необходимо выбрать элементы для массового применения действия');
          return;
        }
        break;
      case 'unload':
        break;
      case 'remove':
        //setShowDeleteClients(true);
        break;
      default:
        return;
    }
  };

  return (
    <>
      <Section>
        <div className="flex text-[20px] mb-[20px]">
          <SectionHeader title="Клиенты размещенные на хостинге" />
        </div>
        <div className="flex justify-between items-center w-full mb-[10px]">
          <div className="flex items-center gap-2 white">
            <DropdownButton
              title={
                <>
                  <span className={'text-[12px] mr-[10px]'}>Все</span>
                  <IconArrowUp opacity="0.3" height="12" width="9" />
                </>
              }
              className="border border-[#262528] bg-[#211F24] px-[10px] rounded-[8px] w-full h-[33px] text-white"
              options={tempLeftActions}
              onSelect={(value: any) => {
                console.log('');
              }}
            />
          </div>
          <div className="flex items-center gap-2 white">
            <DropdownButton
              title={
                <>
                  <span className={'text-[12px] mr-[10px]'}>Действие</span>
                  <IconArrowUp opacity="0.3" height="12" width="9" />
                </>
              }
              className="border border-[#262528] bg-[#211F24] px-[10px] rounded-[8px] w-full h-[33px] text-white"
              options={actions}
              onSelect={(value: any) => {
                handleAction(value);
              }}
            />
          </div>
        </div>
        {null !== clientList ? (
          <>
            {clientList.items.length ? (
              <>
                <Table>
                  <TableThead>
                    <TableTr>
                      <TableActionTh
                        className="w-[3%]"
                        onClick={() => {
                          if (clientList.items.length === bulkItems.length) {
                            setBulkItems([]);
                          } else {
                            setBulkItems(clientList.items.map(item => item.id));
                          }
                        }}
                      />
                      <TableTh
                        title="Имя"
                        className="w-[17%]"
                        sortName="name"
                        sort={sort}
                        onSort={setSort}
                      />
                      <TableTh
                        title="Ник"
                        className="w-[20%]"
                        sortName="nickname"
                        sort={sort}
                        onSort={setSort}
                      />
                      <TableTh
                        title="Номинальная мощнность"
                        className="w-[15%]"
                        sortName="nominal_power"
                        sort={sort}
                        onSort={setSort}
                      />
                      <TableTh
                        title="Фактическая мощность"
                        className="w-[15%]"
                        sortName="actual_power"
                        sort={sort}
                        onSort={setSort}
                      />
                      <TableTh
                        title="Кол-во оборудования"
                        className="w-[15%]"
                        sortName="count_equipment"
                        sort={sort}
                        onSort={setSort}
                      />
                      <TableTh
                        title="Тариф"
                        className="w-[15%]"
                        sortName="tariff"
                        sort={sort}
                        onSort={setSort}
                      />
                    </TableTr>
                  </TableThead>
                  <TableBody>
                    {clientList &&
                      clientList.items.map((client, key) => (
                        <TableTr key={key}>
                          <TableActionTd
                            items={bulkItems}
                            value={client.id}
                            onChange={setBulkItems}
                          />

                          <TableTd
                            title={
                              <Link to={`/hosting/${client.id}`}>
                                <>{client.name ?? '-'}</>
                              </Link>
                            }
                          />

                          <TableTd title={<>{client.nickname ?? '-'}</>} />
                          <TableTd title={`${client.nominal_power ?? '-'}`} />
                          <TableTd title={`${client.actual_power ?? '-'}`} />
                          <TableTd title={`${client.count_equipment ?? '-'}`} />
                          <TableTd title={`${client.tariff ?? '-'}`} />
                        </TableTr>
                      ))}
                  </TableBody>
                </Table>

                {/*<div className='pt-[30px] flex justify-end items-center w-full '>*/}
                {/*    <Paginator*/}
                {/*        totalPages={list.total_pages}*/}
                {/*        page={page.value ? page.value - 1 : 0}*/}
                {/*        perPage={perPage.value ?? DEFAULT_PER_PAGE}*/}
                {/*        onChangePerPage={onChangePerPage}*/}
                {/*        onChangePage={handlePageClick}*/}
                {/*        totalItems={`${list.total_items} хостингов`}*/}
                {/*    />*/}
                {/*</div>*/}
              </>
            ) : (
              <EmptyList />
            )}
          </>
        ) : (
          <ListLoader loading />
        )}
      </Section>
    </>
  );
};

export default HostingClientsTab;
